<template>
    <div>
        <img  :src="content.avatar | fullURL" alt="" class="circle">
        <span class="title">
            <router-link :to="`user/${content._id}`" target="_blank">
                {{content.displayName}}
            </router-link>
        </span>
        <p>
            <span 
                v-if="content.email"
                :class="(content.verifiedEmail ? 'teal' : 'red') + '-text'" class="text-lighten-1"
            >
                <i class="fas fa-envelope"></i> {{content.email}}
            </span>
            <span v-if="content.vkid">
                <i class="fab fa-vk"></i> 
                <a :href="`https://vk.com/id${ content.vkid }`" target="_blank">
                    id{{content.vkid}}
                </a>
            </span>
            <span>
                <i class="far fa-calendar-alt"></i>
                Дата регистрации:
                {{content.createdAt | notificationDateFormat}}
            </span>
            <span>
                <i class="fas fa-signal"></i>
                Последнее посещение:
                {{content.lastVisited | notificationDateFormat}}
            </span>
            <span v-if="content.oldLogin">
                Ранее:
                <a :href="`https://reshimvse.com/profile.php?login=${ content.oldLogin }`" target="_blank">
                    {{content.oldLogin}}
                </a>
            </span>
            <span v-if="content.banned > Date.now()" class="red-text text-lighten-1">
                <i class="fas fa-ban"></i>
                Забанен до {{new Date(content.banned) | notificationDateFormat}}
                по причине: {{content.bannedReason}}
            </span>
            <span 
                v-if="content.rulesOfUse && content.rulesOfUse.includes('post_question_rules_16_04_2021')"
                class="green-text text-lighten-1"
            >
                <i class="fas fa-check"></i>
                Согласился с правилами
            </span>
            <span>
                <i class="far fa-image"></i>
                Подложка:
                {{content.substrate}}
            </span>
            <span>
                <i class="fas fa-bell"></i>
                Уведомлений:
                {{content.countOfReceivedNotifications}}
            </span>

        </p>
        <span class="secondary-content green-text points">{{content.points}} б.</span>
    </div>
</template>

<style scoped>
    p span {
        margin-right: 10px;
    }
</style>

<script>
import CardAvatar from '@/components/basic/CardAvatar.vue'

export default {
    components: { CardAvatar },
    props:{
        content:{
            type: Object
        },
        payload:{
            type: Object
        }
    },
}
</script>